import type { GetServerSidePropsContext, InferGetServerSidePropsType } from 'next';
import { Layout } from '@/components/commons';
import React from 'react';
import { NextPageWithLayout } from '@/pages/_app';
import LandingContent from '@/components/landing/LandingContent';

const LandingPage: NextPageWithLayout<InferGetServerSidePropsType<typeof getServerSideProps>> = () => {
  return <LandingContent />;
};

export async function getServerSideProps({ locale }: GetServerSidePropsContext) {
  return {
    props: {
      messages: (await import(`@/locales/${locale}.json`)).default,
    },
  };
}

LandingPage.getLayout = (page: React.ReactElement) => {
  return <Layout>{page}</Layout>;
};

export default LandingPage;
